import { gql } from '@apollo/client'

export const PROCESS_ACTIVE_DIRECTORY_CODE = gql`
  mutation PROCESS_ACTIVE_DIRECTORY_CODE($code: String!) {
    activeDirectoryProcessAdminCode(code: $code) {
      ok
    }
  }
`

export const SYNC_ACTIVE_DIRECTORY = gql`
  mutation SYNC_ACTIVE_DIRECTORY {
    activeDirectorySync {
      ok
    }
  }
`

export const DELETE_ACTIVE_DIRECTORY = gql`
  mutation DELETE_ACTIVE_DIRECTORY($input: ActiveDirectoryDeleteInput!) {
    activeDirectoryDelete(input: $input) {
      ok
    }
  }
`

export const UPDATE_ACTIVE_DIRECTORY = gql`
  mutation UPDATE_ACTIVE_DIRECTORY($input: TokenUpdateInput!) {
    tokenUpdate(input: $input) {
      ok
    }
  }
`
